import React from 'react';
import { Helmet } from 'react-helmet';
import { Result } from 'antd';
import Translated from 'components/Translated';
import { getTranslated } from 'utils';


const Error401 = ({ locale }) => (
    <div className="gx-page-error-container">
        <Helmet>
            <title>{getTranslated('error.404.title', locale)}</title>
        </Helmet>

        <Result
            status="403"
            title={<Translated id="error.401.title" />}
            subTitle={<Translated id="error.401.description" />}
        />
    </div>
);

export default Error401;
